import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { makeCurrentUser } from '@actions/userActions';
import { getTokenFromStore } from '@utils';
import { useNavigate } from 'react-router-dom';
import { AuthPaths, Paths } from '@constants/paths';
import { loading } from '@actions/commonActions';

export const useTestLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = getTokenFromStore();

  useEffect(() => {
    if (token) {
      dispatch(makeCurrentUser());
    } else {
      dispatch(loading(false, 'app'));
      navigate(`${Paths.AUTH}/${AuthPaths.TEST_LOGIN}`);
    }
  }, []);
};
